module.exports = __webpack_public_path__ + "static/media/game-interviewer11.c5fb6d1d.png";